import {Form, Input, Space, Button, message, Spin, Row, Col, Card, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from 'axios';
import {CloseOutlined, SaveOutlined, UserOutlined, MailOutlined, PhoneOutlined, HomeOutlined, IdcardOutlined} from '@ant-design/icons';
import {useTranslation} from "react-i18next";
import { parsePhoneNumberFromString , isValidPhoneNumber  } from 'libphonenumber-js';

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});

const FormAddPersona = ({accion}) => {
    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
    };

    const [messageApi, contextHolder] = message.useMessage();
    const [spinning, setSpinning] = useState(false);
    const [spinTitle, setSpinTitle] = useState("Guardando información ...");
    const [title] = useState((accion === "mod") ? "Modificar Persona" : "Adicionar Persona");
    const navigate = useNavigate();
    const {id} = useParams();
    const [form] = Form.useForm();
    const {t, i18n} = useTranslation();

    const validateEmail = (rule, value, callback) => {
        if (value) {
            const emailRegex = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
            if (accion !== "pass" && !emailRegex.test(value)) {
                callback('Correo Inválido / Invalid email address');
            } else {
                callback();
            }
        }else{
            return Promise.resolve();
        }
    };

    const validatePhoneNumber = (rule, value) => {
        if (!value) {
            return Promise.reject('El número de teléfono es obligatorio');
        }

        // Usa parsePhoneNumberFromString para validar con distintos formatos
        const phoneNumberUS = parsePhoneNumberFromString(value, 'US');
        const phoneNumberCuba = parsePhoneNumberFromString(value, 'CU');

        // Comprueba si el número es válido para EE. UU. o Cuba
        if ((phoneNumberUS && phoneNumberUS.isValid()) || (phoneNumberCuba && phoneNumberCuba.isValid())) {
            return Promise.resolve();
        }

        return Promise.reject('Número de teléfono no válido para EE. UU. o Cuba');
    };

    useEffect(() => {
        if (accion === "mod") {
            if (!sessionStorage.getItem('user_mod')) {
                navigate('/persona');
            } else {
                let user_mod = JSON.parse(sessionStorage.getItem('user_mod'));
                form.setFieldsValue({
                    "nombre": user_mod.nombre,
                    "papell": user_mod.papell,
                    "sapell": user_mod.sapell,
                    "correo": user_mod.correo,
                    "carnet": user_mod.carnet,
                    "telefono": user_mod.telefono,
                    "direccion": user_mod.direccion
                });
            }
        }
    }, []);

    const cancelar = () => {
        navigate('/persona');
    };

    const onFinish = (values) => {
        if (spinning) return;
        values.idpersona = id;
        setSpinning(true);

        let message;

        if (accion === "add") {
            setSpinTitle('Guardando datos...');
            Axios.post("sd/addPersona", values, {headers})
                .then(response => {
                    setSpinning(false);
                    message = response.data.message;
                    if (response.data.success) {
                        messageApi.open({
                            type: 'success',
                            content: response.data.message,
                        });
                        setTimeout(messageApi.destroy, 3500);
                        navigate('/persona');
                    } else {
                        messageApi.open({type: 'error', content: message});
                        setTimeout(messageApi.destroy, 3500);
                    }
                })
                .catch(() => {
                    setSpinning(false);
                    messageApi.open({type: 'error', content: message});
                    setTimeout(messageApi.destroy, 3500);
                });
        } else if (accion === "mod") {
            setSpinTitle('Guardando datos...');
            Axios.post("sd/updatePersona", values, {headers})
                .then(response => {
                    setSpinning(false);
                    if (response.data.success) {
                        messageApi.open({
                            type: 'success',
                            content: response.data.message,
                        });
                        setTimeout(messageApi.destroy, 2500);
                        navigate('/persona');
                    } else {
                        messageApi.open({type: 'error', content: 'Error al guardar los datos'});
                        setTimeout(messageApi.destroy, 2500);
                    }
                })
                .catch(() => {
                    setSpinning(false);
                    messageApi.open({type: 'error', content: 'Error al guardar los datos'});
                    setTimeout(messageApi.destroy, 2500);
                });
        }
    };

    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "16px"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                {/* Header Principal */}
                <div style={{
                    background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                    borderRadius: '8px',
                    padding: '12px',
                    marginBottom: '16px',
                    color: 'white',
                    boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)',
                    textAlign: 'center'
                }}>
                    <UserOutlined style={{ fontSize: '24px', marginBottom: '8px' }} />
                    <Typography.Title level={4} style={{ color: 'white', margin: 0 }}>
                        {title}
                    </Typography.Title>
                    <Typography.Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}>
                        {accion === "add" ? "Complete los campos para registrar" : "Modifique los datos"}
                    </Typography.Text>
                </div>

                {contextHolder}

                {/* Formulario Principal */}
                <Row justify="center">
                    <Col xs={24} sm={22} md={20} lg={18} xl={16}>
                        <Card
                            style={{
                                borderRadius: '16px',
                                boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                                border: 'none'
                            }}
                            bodyStyle={{ padding: '32px' }}
                        >
                            <Form
                                form={form}
                                autoComplete="on"
                                onFinish={onFinish}
                                layout="vertical"
                                initialValues={{activo: 1}}
                            >
                                {/* Sección de Datos Personales */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                    borderRadius: '12px',
                                    padding: '24px',
                                    marginBottom: '24px',
                                    border: '1px solid #e0e6ff'
                                }}>
                                    <Typography.Title level={4} style={{ color: '#253289', marginBottom: '20px' }}>
                                        <UserOutlined style={{ marginRight: '8px' }} />
                                        Datos Personales
                                    </Typography.Title>

                                    <Row gutter={16}>
                                        <Col xs={24} sm={8}>
                                            <Form.Item
                                                name="nombre"
                                                label={<span style={{ color: '#253289', fontWeight: '500' }}>Nombre</span>}
                                                rules={[{required: true, message: 'Por favor debe poner el nombre!'}]}
                                            >
                                                <Input
                                                    prefix={<UserOutlined style={{ color: '#253289' }} />}
                                                    placeholder="Ingrese el nombre"
                                                    size="large"
                                                    style={{ borderRadius: '8px' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <Form.Item
                                                name="papell"
                                                label={<span style={{ color: '#253289', fontWeight: '500' }}>Primer apellido</span>}
                                                rules={[{required: true, message: 'Por favor debe poner el primer apellido!'}]}
                                            >
                                                <Input
                                                    prefix={<UserOutlined style={{ color: '#253289' }} />}
                                                    placeholder="Ingrese el primer apellido"
                                                    size="large"
                                                    style={{ borderRadius: '8px' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <Form.Item
                                                name="sapell"
                                                label={<span style={{ color: '#253289', fontWeight: '500' }}>Segundo apellido</span>}
                                                rules={[{required: true, message: 'Por favor debe poner el segundo apellido!'}]}
                                            >
                                                <Input
                                                    prefix={<UserOutlined style={{ color: '#253289' }} />}
                                                    placeholder="Ingrese el segundo apellido"
                                                    size="large"
                                                    style={{ borderRadius: '8px' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Sección de Identificación y Contacto */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                    borderRadius: '12px',
                                    padding: '24px',
                                    marginBottom: '24px',
                                    border: '1px solid #e0e6ff'
                                }}>
                                    <Typography.Title level={4} style={{ color: '#253289', marginBottom: '20px' }}>
                                        <IdcardOutlined style={{ marginRight: '8px' }} />
                                        Identificación y Contacto
                                    </Typography.Title>

                                    <Row gutter={16}>
                                        <Col xs={24} sm={8}>
                                            <Form.Item
                                                name="carnet"
                                                label={<span style={{ color: '#253289', fontWeight: '500' }}>CI / Pasaporte</span>}
                                                rules={[
                                                    {required: true, message: 'Por favor debe poner CI o Pasaporte!'},
                                                    {min: 8, message: 'Debe introducir al menos 8 caracteres'},
                                                    {max: 11, message: 'No debe introducir más de 11 caracteres'}
                                                ]}
                                            >
                                                <Input
                                                    prefix={<IdcardOutlined style={{ color: '#253289' }} />}
                                                    placeholder="Ingrese CI o Pasaporte"
                                                    size="large"
                                                    style={{ borderRadius: '8px' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <Form.Item
                                                name="correo"
                                                label={<span style={{ color: '#253289', fontWeight: '500' }}>Correo electrónico</span>}
                                                rules={[{ required: false, message: 'Por favor debe poner el correo!' },{ validator: validateEmail }]}
                                            >
                                                <Input
                                                    prefix={<MailOutlined style={{ color: '#253289' }} />}
                                                    placeholder="ejemplo@correo.com"
                                                    size="large"
                                                    style={{ borderRadius: '8px' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <Form.Item
                                                name="telefono"
                                                label={<span style={{ color: '#253289', fontWeight: '500' }}>Teléfono</span>}
                                                rules={[
                                                    {validator: validatePhoneNumber,}
                                                ]}
                                            >
                                                <Input
                                                    prefix={<PhoneOutlined style={{ color: '#253289' }} />}
                                                    placeholder="+1 234 567 8900"
                                                    size="large"
                                                    style={{ borderRadius: '8px' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Sección de Dirección */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                    borderRadius: '12px',
                                    padding: '24px',
                                    marginBottom: '24px',
                                    border: '1px solid #e0e6ff'
                                }}>
                                    <Typography.Title level={4} style={{ color: '#253289', marginBottom: '20px' }}>
                                        <HomeOutlined style={{ marginRight: '8px' }} />
                                        Dirección
                                    </Typography.Title>

                                    <Form.Item
                                        name="direccion"
                                        label={<span style={{ color: '#253289', fontWeight: '500' }}>Dirección completa</span>}
                                        rules={[{required: true, message: 'Por favor debe poner la dirección!'}]}
                                    >
                                        <Input
                                            prefix={<HomeOutlined style={{ color: '#253289' }} />}
                                            placeholder="Ingrese la dirección completa"
                                            size="large"
                                            style={{ borderRadius: '8px' }}
                                        />
                                    </Form.Item>
                                </div>

                                {/* Botones de acción */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                    borderRadius: '12px',
                                    padding: '24px',
                                    textAlign: 'center',
                                    border: '1px solid #e0e6ff'
                                }}>
                                    <Space size="large">
                                        <Button
                                            icon={<CloseOutlined />}
                                            danger
                                            onClick={cancelar}
                                            size="large"
                                            style={{
                                                borderRadius: '8px',
                                                minWidth: '120px',
                                                height: '44px',
                                                fontWeight: '500'
                                            }}
                                        >
                                            {t('global.cancel')}
                                        </Button>
                                        <Button
                                            icon={<SaveOutlined />}
                                            type="primary"
                                            htmlType="submit"
                                            size="large"
                                            disabled={spinning}
                                            style={{
                                                background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                                borderColor: '#253289',
                                                borderRadius: '8px',
                                                minWidth: '120px',
                                                height: '44px',
                                                fontWeight: '500',
                                                boxShadow: '0 4px 12px rgba(37, 50, 137, 0.3)'
                                            }}
                                        >
                                            {t('global.save')}
                                        </Button>
                                    </Space>
                                </div>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Spin>
        </div>
    );
};

export default FormAddPersona;
